// extracted by mini-css-extract-plugin
module.exports = {"empty":"styles_empty_3sLglOxrgsxMQLbjz165m6","message":"styles_message_KOgaVsguumB7k87DcmrmX","icon":"styles_icon_3G5qmxjL29H6-uTix4fIOu"};